// Component Name:  StatusMessage component
// Author: Lavanya S
// Platform:
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date: 22-05-2025
// Description:  This component is designed to display the status (Success or failure)
// Dependencies: React library,
// Interfaces: props
// Maintenance History: 1.0 First Version

import React, { Component } from "react";
import { Row, Col, Container } from "reactstrap";
import { Link } from "react-router-dom";
// import images
import logodark from "../../assets/images/logo-dark.png";
import LKCompletedImg from "../../assets/images/LK_Icons/LK__Completed.svg";
import LKErrImg from "../../assets/images/LK_Icons/LK__Error.svg";

import { ActiveBtn } from "../Utility/Button";
import { connect } from "react-redux";

/**
 * StatusMessage component
 * Currently this is used to shown the password change success or failure.
 * In future based on requirement can be customized to display the title,message(through props)
 *
 * parameter is sent through link and is accessible through (this.props.location.state)
 * @param {boolean} isSuccess - based on this success or failure password reset message will be displayed.
 */
class StatusMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleStatusClick = () => {
    const { isSuccess } = this.props.location?.state;
    if (isSuccess) {
      this.props.history.push("/login");
    } else {
      const secondsPassed = Math.floor((Date.now() - this.props.OTPTime) / 1000);
      const timeLeft = 600 - secondsPassed;
      console.log("timeLeft: ", timeLeft);

      if (timeLeft <= 0) {
        this.props.history.push("/login");
      } else {
        this.props.history.push("/reset-password");
      }
    }
  };
  render() {
    const { isSuccess } = this.props.location?.state;
    return (
      <React.Fragment>
        <div>
          <Container fluid className="p-0">
            <Row className="no-gutters">
              <div className="authentication-bg" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100vh" }}>
                <div className="bg-overlay"></div>
              </div>
              <Col xs={12} className="p-0">
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    minHeight: "100vh",
                    width: "100%",
                  }}
                >
                  <div
                    className="p-4"
                    style={{
                      maxWidth: "600px",
                      backgroundColor: "#FFFFFF",
                      boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    }}
                  >
                    <Row className="justify-content-center">
                      <Col lg={12}>
                        <div>
                          <div className="d-flex flex-column justify-content-center align-items-center">
                            <div>
                              <Link to="/" className="logo">
                                <img src={logodark} height="40" alt="logo" />
                              </Link>
                            </div>
                            <img src={isSuccess ? LKCompletedImg : LKErrImg} style={{ width: "60px", height: "60px" }} />

                            <h4 className="font-size-18 mt-3">{isSuccess ? "Password Changed" : "Failed to update Password"}</h4>
                            <p className="text-muted mb-3">{isSuccess ? "Your password has been changed Successfully" : "Failed to update with the new password"}</p>
                            <ActiveBtn name={isSuccess ? "Back to Log In" : "Back"} handleClick={this.handleStatusClick} />
                          </div>

                          <div className="p-2 mt-1"></div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  OTPTime: state?.Forget?.OTPTime,
});
export default connect(mapStateToProps)(StatusMessage);
